import React from "react";
import clsx from 'clsx';
import { 
  Card, CardContent, Grid
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import MoneyFormatter from "../../../../../../utils/money_formatter.js";

const styles = theme => ({
  question: {
    flexWrap: "wrap",
    display: "flex",
  },
  title: {
    flexGrow: "1",
    flexBasis: "100%"
  },
  answer: {
    flexGrow: "1",
    flexBasis: "100%",
    margin: "8px 0px",
    display: "block"
  }
});

const QuestionnaireCard = (props) => {

  const { classes } = props;

  const user = props.user || {};
  const questionnaire = user.questionnaire || {};

  const moneyFormat = (value) => {
    return MoneyFormatter.format(value, "0,0[,][00]");
  };

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.questionnaire")}
        </div>
        {
          (!questionnaire.data || questionnaire.data.length === 0) &&
          <span className = { clsx(classes.value, classes.answer) } >
            { "-" }
          </span>
        }
        <Grid container spacing = { 3 } >
          {
            (questionnaire.data || []).map((question) => {
              let value = "-";
              if(question.type === "single") {
                let values = question.availableValues.filter(v => v.key === question.singleValueKey)
                if(values.length > 0) {
                  value = values.map(v => v.title).join(", ");
                }
                
              }
              if(question.type === "multiple") {
                let values = question.availableValues.filter(v => (question.multipleValueKeys || []).includes(v.key));
                if(values.length > 0) {
                  value = values.map(v => v.title).join(", ");
                }
              }
              if(question.type === "number" && question.numberValue) {
                value = moneyFormat(question.numberValue);
              }
              return <Grid item sm = { 12 }
                           key = { question.key }
                           className = { classes.question } >
                <span className = { clsx(classes.label, classes.title) } >
                  { `${question.title}` }
                </span>
                <span className = { clsx(classes.value, classes.answer) } >
                  { value }
                </span>
              </Grid>
            })
          }
        </Grid>
      </CardContent>
    </Card>
  );
}

QuestionnaireCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(QuestionnaireCard);